import { useEffect, useState } from "react";
import Seo from "./components/Seo";
import Header from "./components/Header";
import Hero from "./components/Hero";
import HotRank from "./components/HotRank";
import Feeds from "./components/Feeds";
import Feature from "./components/Feature";
import Timeline from "./components/Timeline";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";
import ReadingModal from "./components/ReadingModal";
import { faqs, type Article } from "@/mocks/feed";

export default function Home() {
  const [reading, setReading] = useState<Article | null>(null);
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 700);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const jsonLd: Record<string, unknown>[] = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "吃瓜网上",
      url: window.location.origin,
      description: "吃瓜网上今日热点全网汇总，新鲜事一网打尽。",
      inLanguage: "zh-CN",
      potentialAction: {
        "@type": "SearchAction",
        target: `${window.location.origin}/?q={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "吃瓜网上",
      url: window.location.origin,
      email: "chiguawang@example.com",
      description: "面向全网网友的热点聚合与浏览页面，汇总今日热榜、分类速递与深度盘点。",
    },
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: "吃瓜网上 - 今日热点全网汇总",
      url: window.location.href,
      inLanguage: "zh-CN",
      isPartOf: { "@type": "WebSite", name: "吃瓜网上", url: window.location.origin },
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
  ];

  return (
    <div className="relative min-h-screen bg-background-50">
      <Seo
        title="吃瓜网上 - 今日热点全网汇总 · 新鲜事一网打尽"
        description="吃瓜网上今日热点全网汇总，热门事件、焦点话题一网打尽。每天更新最新鲜的瓜，不用到处翻，一个页面看遍全网热点，轻松掌握今日吃瓜风向。"
        canonicalPath="/"
        jsonLd={jsonLd}
      />

      <Header />

      <main>
        <Hero />
        <HotRank onRead={setReading} />
        <Feeds onRead={setReading} />
        <Feature onRead={setReading} />
        <Timeline />
        <About />
        <Faq />
      </main>

      <Footer />

      <ReadingModal article={reading} onClose={() => setReading(null)} onRead={setReading} />

      {showTop && (
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          aria-label="回到顶部"
          className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-soft hover:bg-primary-600 transition-all cursor-pointer"
        >
          <i className="ri-arrow-up-line text-xl" aria-hidden="true"></i>
        </button>
      )}
    </div>
  );
}